export const MAX_SLOT_FILLS = 3;
export function slotFills(slots, slotId) {
    const raw = slots === null || slots === void 0 ? void 0 : slots[slotId];
    if (!raw)
        return [];
    const list = Array.isArray(raw) ? raw : [raw];
    return list.filter(Boolean).slice(0, MAX_SLOT_FILLS);
}
export function allSlotFills(slots) {
    return Object.values(slots !== null && slots !== void 0 ? slots : {}).flatMap((raw) => Array.isArray(raw) ? raw : raw ? [raw] : []);
}
